
import CcpaPolicy from "./company/CcpaPolicy";

export { Page }

function Page() {
  return <CcpaPolicy />;
}
